/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { is } from 'bpmn-js/lib/util/ModelUtil';

import { createDmnModdle, traverseModdle } from './moddle-util';

export const getDecisions = async (definitions) => {
  const decisions = [];

  traverseModdle(definitions, (element) => {
    if (is(element, 'dmn:Decision')) {
      decisions.push({ id: element.get('id'), name: element.get('name') || '' });
    }
  });

  return decisions;
};

export const getDecisionsFromXML = async (xml) => {
  try {
    const dmnModdle = createDmnModdle();

    const { rootElement } = await dmnModdle.fromXML(xml);

    return getDecisions(rootElement);
  } catch (err) {
    console.error(err);

    return [];
  }
};
